(function () {
  var rtl = document.documentElement.dir === 'rtl';
  var html = document.documentElement;

  function money(cents) {
    var fmt = (window.KSX_CART && window.KSX_CART.moneyFormat) || '{{amount}}';
    var n = (cents / 100);
    function f(d, ts, ds) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p.join(ds); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return f(0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(0, '.', ',');
      return f(2, ',', '.');
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function reinit(el) { el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true })); }

  /* ---------- mega menu ---------- */
  function initMega(root) {
    if (root.__n1) return; root.__n1 = true;
    var btn = root.querySelector('[data-n1-mega-toggle]');
    var panel = root.querySelector('[data-n1-mega-panel]');
    if (!btn || !panel) return;
    var t = null;
    var hoverable = window.matchMedia('(hover: hover)').matches;
    function open() { clearTimeout(t); panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); }
    function close() { clearTimeout(t); panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function () { panel.hidden ? open() : close(); });
    if (hoverable) {
      [btn, panel].forEach(function (el) {
        el.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(open, 120); });
        el.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(close, 220); });
      });
    }
    function show(i) {
      root.querySelectorAll('[data-n1-mega-cat]').forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-n1-mega-cat') === i); });
      root.querySelectorAll('[data-n1-mega-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-n1-mega-pane') !== i; });
    }
    root.querySelectorAll('[data-n1-mega-cat]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { show(a.getAttribute('data-n1-mega-cat')); });
      a.addEventListener('focus', function () { show(a.getAttribute('data-n1-mega-cat')); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { close(); btn.focus(); } });
    document.addEventListener('click', function (e) { if (!panel.hidden && !root.contains(e.target)) close(); });
  }

  /* ---------- listing filters ---------- */
  function initPlp(root) {
    if (root.__n1) return; root.__n1 = true;
    var side = root.querySelector('[data-n1-filters]');
    var form = root.querySelector('[data-n1-filter-form]');
    function go(params) { var u = new URL(form ? form.action : location.href, location.origin); u.search = params.toString(); location.href = u.toString(); }
    function formParams() { var p = new URLSearchParams(); new FormData(form).forEach(function (v, k) { if (v !== '') p.append(k, v); }); return p; }
    if (form) {
      form.addEventListener('change', function (e) { if (e.target.matches('[data-n1-fcheck]')) go(formParams()); });
      form.addEventListener('submit', function (e) { e.preventDefault(); go(formParams()); });
    }
    root.querySelectorAll('[data-n1-fsearch]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var q = inp.value.trim().toLowerCase();
        inp.parentNode.querySelectorAll('[data-n1-fval]').forEach(function (li) { li.hidden = q && li.getAttribute('data-n1-fval').indexOf(q) === -1; });
      });
    });
    var sort = root.querySelector('[data-n1-sort]');
    if (sort) sort.addEventListener('change', function () { var p = new URLSearchParams(location.search); p.set('sort_by', sort.value); p.delete('page'); location.search = p.toString(); });
    function setOpen(on) { if (!side) return; side.classList.toggle('is-open', on); html.style.overflow = on ? 'hidden' : ''; }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-n1-filters-open]')) setOpen(true);
      else if (e.target.closest('[data-n1-filters-close]')) setOpen(false);
    });
  }

  /* ---------- product page ---------- */
  function initPdp(root) {
    if (root.__n1) return; root.__n1 = true;
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-n1-variants]').textContent); } catch (e) {}
    var form = root.querySelector('[data-n1-form]');
    var stage = root.querySelector('[data-n1-stage]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-n1-thumb]'));
    var slides = stage ? [].slice.call(stage.children) : [];
    var gdots = root.querySelector('[data-n1-gdots]');
    var idx = 0;

    function goSlide(i, smooth) {
      if (!stage || !slides[i]) return;
      var tr = stage.getBoundingClientRect(), r = slides[i].getBoundingClientRect();
      stage.scrollBy({ left: r.left - tr.left, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function paint() {
      if (!stage) return;
      var tr = stage.getBoundingClientRect(), best = 0, d = 1e9;
      slides.forEach(function (s, i) { var dd = Math.abs(s.getBoundingClientRect().left - tr.left); if (dd < d) { d = dd; best = i; } });
      idx = best;
      thumbs.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
      if (gdots) [].forEach.call(gdots.children, function (b, i) { b.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
    if (gdots && slides.length > 1) slides.forEach(function (_, i) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (i + 1) + ' / ' + slides.length); b.addEventListener('click', function () { goSlide(i); }); gdots.appendChild(b); });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { goSlide(+b.getAttribute('data-n1-thumb')); }); });
    if (stage) {
      var q = false;
      stage.addEventListener('scroll', function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; paint(); }); }, { passive: true });
      var start = +(root.querySelector('[data-n1-gallery]').getAttribute('data-start') || 0);
      if (start) requestAnimationFrame(function () { goSlide(start, false); });
      paint();
    }

    if (!form) return;
    var vid = form.querySelector('[data-n1-vid]');
    var addBtn = form.querySelector('[data-n1-add]');
    var addLabel = form.querySelector('[data-n1-add-label]');
    var err = form.querySelector('[data-n1-err]');
    var fieldsets = [].slice.call(form.querySelectorAll('[data-n1-option]'));

    function selected() { return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function find(opts) { return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }); }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var v = find(test);
          var lab = inp.nextElementSibling;
          if (lab) lab.classList.toggle('is-na', !v || !v.available);
        });
        var c = fs.querySelector('input:checked'), out = fs.querySelector('[data-n1-optval]');
        if (c && out) out.textContent = c.value;
      });
    }
    function update() {
      var opts = selected();
      var v = find(opts);
      markAvailability(opts);
      var priceBox = root.querySelector('[data-n1-pricebox]');
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = addBtn.getAttribute('data-l-na');
        return;
      }
      vid.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = addBtn.getAttribute(v.available ? 'data-l-add' : 'data-l-sold');
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      root.querySelector('[data-n1-price]').textContent = money(v.price);
      var cmp = root.querySelector('[data-n1-compare]'), pct = root.querySelector('[data-n1-pct]');
      cmp.hidden = pct.hidden = !sale;
      if (sale) { cmp.textContent = money(v.compare_at_price); pct.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      priceBox.classList.toggle('is-sale', !!sale);
      var flag = root.querySelector('[data-n1-flag]');
      if (flag) { flag.hidden = !sale; if (sale) flag.textContent = pct.textContent; }
      var sku = root.querySelector('[data-n1-sku]'); if (sku) sku.textContent = v.sku || '—';
      if (v.featured_media) {
        var i = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == v.featured_media.id; });
        if (i > -1) goSlide(i);
      }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
    form.addEventListener('change', function (e) { if (e.target.type === 'radio') update(); });
    if (fieldsets.length) markAvailability(selected());

    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-n1-qty]');
      if (!b) return;
      var inp = form.querySelector('input[name=quantity]');
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (+b.getAttribute('data-n1-qty')));
    });
    form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name !== 'add') return;
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.classList.add('is-loading'); err.hidden = true;
      fetch(((window.KSX_LOCALE && window.KSX_LOCALE.root) || '/').replace(/\/?$/, '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('ksx:cart-updated'));
          var opener = document.querySelector('[data-ksx-cart-open]');
          if (opener) opener.click(); else location.href = '/cart';
        })
        .catch(function (x) { err.textContent = x.message; err.hidden = false; })
        .then(function () { addBtn.classList.remove('is-loading'); });
    });

    var box = root.querySelector('[data-n1-together]');
    if (box) {
      var base = box.getAttribute('data-url');
      var list = box.querySelector('[data-n1-together-list]');
      fetch(base + '&intent=complementary').then(function (r) { return r.json(); })
        .then(function (j) { return (j.products && j.products.length) ? j : fetch(base + '&intent=related').then(function (r) { return r.json(); }); })
        .then(function (j) {
          var ps = (j.products || []).slice(0, 6);
          if (!ps.length) return;
          list.innerHTML = ps.map(function (p) {
            var v = p.variants && p.variants[0];
            var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=160' : p.featured_image + '?width=160') : '';
            var add = (p.variants.length === 1 && v && v.available) ? '<button type="button" class="n1-add" data-ksx-add="' + v.id + '" aria-label="+">' + (document.querySelector('.n1-add svg') ? document.querySelector('.n1-add svg').outerHTML : '+') + '</button>' : '';
            return '<div class="n1-mini">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '') +
              '<div class="n1-mini__body"><div class="n1-mini__v">' + esc(p.vendor) + '</div><a class="n1-mini__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
              '<div class="n1-mini__p">' + money(p.price) + (p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '') + '</div></div>' + add + '</div>';
          }).join('');
          box.hidden = false;
        }).catch(function () {});
    }
  }

  function initRelated(root) {
    if (root.__n1) return; root.__n1 = true;
    if (root.querySelector('.n1-card')) return;
    var url = root.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      var d = document.createElement('div'); d.innerHTML = t;
      var inner = d.querySelector('[data-n1-related]');
      if (inner && inner.querySelector('.n1-card')) { root.innerHTML = inner.innerHTML; reinit(root); }
    }).catch(function () {});
  }

  function initBrands(inp) {
    if (inp.__n1) return; inp.__n1 = true;
    inp.addEventListener('input', function () {
      var q = inp.value.trim().toLowerCase();
      document.querySelectorAll('[data-n1-bgroup]').forEach(function (g) {
        var any = false;
        g.querySelectorAll('[data-n1-bname]').forEach(function (li) { var m = !q || li.getAttribute('data-n1-bname').indexOf(q) > -1; li.hidden = !m; if (m) any = true; });
        g.hidden = !any;
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-n1-mega]').forEach(initMega);
    scope.querySelectorAll('[data-n1-plp]').forEach(initPlp);
    scope.querySelectorAll('[data-n1-pdp]').forEach(initPdp);
    scope.querySelectorAll('[data-n1-related]').forEach(initRelated);
    scope.querySelectorAll('[data-n1-bsearch]').forEach(initBrands);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
